import React from 'react';

const JGK_PER_USD = 1000;

const formatUsd = (amountJgk) => {
  const value = Number(amountJgk || 0) / JGK_PER_USD;
  if (!Number.isFinite(value)) return '$0.00';
  return `$${value.toFixed(2)}`;
};

const formatMethod = (value) => {
  const raw = String(value || '').trim();
  if (!raw) return 'Unknown';
  return raw
    .replace(/[_-]+/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
};

const formatTimestamp = (value) => {
  if (!value) return 'Unknown time';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'Unknown time';
  return date.toLocaleString();
};

const resolvePlayerLabel = (item) => {
  return item?.playerId || item?.player?.playerId || 'Player';
};

const resolveAvatarUrl = (item) => {
  return (
    item?.profilePhoto ||
    item?.player?.profilePhoto ||
    '/assets/person/noAvatar.png'
  );
};

export default function JGKCashoutAdminList({
  requests = [],
  onMarkPaid,
  processingId = null,
}) {
  if (!requests.length) {
    return (
      <div className="jgk-wallet__empty">No pending cashout requests.</div>
    );
  }

  const statusLabel = (status) => {
    const s = String(status || '').toLowerCase();
    if (s === 'paid') return 'Paid';
    if (s === 'rejected') return 'Rejected — JGK Returned';
    return 'Reserved — Awaiting Processing';
  };

  return (
    <div className="jgk-wallet__history">
      {requests.map((item) => {
        const id = item?._id || item?.id || '';
        const amount = Number(item?.amountJGK ?? item?.amount ?? 0);
        const usd = formatUsd(amount);
        const method = formatMethod(item?.method || item?.cashoutMethod);
        const handle =
          item?.handle ||
          item?.payoutHandle ||
          item?.accountHandle ||
          'Not provided';
        const createdAt = formatTimestamp(item?.createdAt || item?.created_at);
        const playerLabel = resolvePlayerLabel(item);
        const avatarUrl = resolveAvatarUrl(item);
        const isProcessing = processingId === id;

        return (
          <div className="jgk-wallet__history-item" key={id || createdAt}>
            <div className="jgk-wallet__history-icon" aria-hidden="true">
              <img
                src={avatarUrl}
                alt=""
                loading="lazy"
                onError={(event) => {
                  event.currentTarget.src = '/assets/person/noAvatar.png';
                }}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  borderRadius: 10,
                }}
              />
            </div>
            <div className="jgk-wallet__history-body">
              <div className="jgk-wallet__history-title">{playerLabel}</div>
              <div className="jgk-wallet__history-sub">
                {`Method: ${method} - Handle: ${handle}`}
              </div>
              <div className="jgk-wallet__history-sub">
                {`Requested: ${createdAt}`}
              </div>
              <div className="jgk-wallet__history-sub">
                {statusLabel(item?.status)}
              </div>
            </div>
            <div className="jgk-wallet__history-amount">
              {`JGK ${Number.isFinite(amount) ? amount.toFixed(2) : '0.00'}`}
              <div className="jgk-wallet__history-sub">{usd}</div>
            </div>
            <button
              type="button"
              className="jgk-wallet__learn-button"
              onClick={() => onMarkPaid?.(item)}
              disabled={isProcessing}
            >
              {isProcessing ? 'Marking...' : 'Mark as Paid'}
            </button>
          </div>
        );
      })}
    </div>
  );
}
